import { twMerge } from 'tailwind-merge';
import { Heading } from '../..';
import { IconNames } from '../../util/types';
import Icon from '../Icon/icon';

export interface CardProps {
  iconName?: IconNames;
  title?: string;
  content?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

const Card = ({
  content = undefined,
  iconName = undefined,
  title = '',
  footer = undefined,
  className = '',
  ...props
}: CardProps) => {
  return (
    <div
      {...props}
      className={twMerge(
        'preflight ds-flex ds-flex-col ds-items-start ds-gap-6 ds-rounded-lg ds-border ds-border-neutrals-light ds-p-5',
        className
      )}
    >
      {title && (
        <div className="ds-flex ds-flex-row ds-items-center ds-gap-3">
          {iconName && (
            <Icon
              size="medium"
              name={iconName}
              className="ds-text-neutrals-darker"
              hasIndicator={false}
              altText={iconName}
            />
          )}
          <Heading size="small" text={title} hasMarginBottom={false} />
        </div>
      )}
      {content && <div className="ds-text-base">{content}</div>}
      {footer && <div>{footer}</div>}
    </div>
  );
};

export default Card;
